module.exports = __webpack_public_path__ + "img/support_jp.28daaab.jpg";